import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { ToastContainer, toast } from "react-toastify";
import { postApi } from "../../services/apiController";
import { packages } from "./TravelDeals";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import SuggestionComponent from "./Suggestions";

const TourPackageDetail = () => {
  const [currentPackage, setCurrentPackage] = useState({
    title: "",
  });
  const theme = useSelector((state) => state.theme.theme); // Assuming 'theme' holds 'dark' or 'light'
  const isDarkTheme = theme === "dark";

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const formattedValues = {
        ...values,
        date: dayjs(values.date).format("DD/MM/YYYY"), // Format date here
      };
      const res = await postApi("postQuery", formattedValues);
      toast.success(res.message);
      resetForm();
    } catch (error) {
      console.log(error, "error");
      toast.error(error.message);
    } finally {
      setSubmitting(false);
    }
  };
  const themeClasses = isDarkTheme
    ? "bg-black text-white"
    : "bg-white text-black";

  const cardClasses = isDarkTheme
    ? "bg-indigo-500 text-white"
    : "bg-[#5b53fb] text-white";

  const heroOverlayClasses = isDarkTheme
    ? "bg-black bg-opacity-50"
    : "bg-white bg-opacity-70";

  const formSectionClasses = isDarkTheme
    ? "bg-black border-teal-400"
    : "bg-gray-50 border-teal-300";

  const [openIndices, setOpenIndices] = useState([]);

  const toggleAccordion = (index) => {
    // Check if the index is already in the array
    if (openIndices.includes(index)) {
      // If it is, remove it to close the item
      setOpenIndices(openIndices.filter((i) => i !== index));
    } else {
      // If it isn't, add it to the array to open the item
      setOpenIndices([...openIndices, index]);
    }
  };

  // Carousel settings
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  const location = useLocation();
  const tripInfo = packages;
  const tripId = decodeURI(location.pathname).replace("/packages/", "");
  const handleWhatsappClick = () => {
    const message = "Hello, I'm interested in your tour packages.";
    const whatsappUrl = `https://api.whatsapp.com/send?phone=917742386069&text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  useEffect(() => {
    const res = { ...packages.filter((item) => item.title === tripId)[0] };
    setCurrentPackage(res);
  }, []);
  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const {
    title,
    pricing,
    originalPrice,
    duration,
    features,
    itinerary,
    inclusions,
    exclusions,
    imageUrl,
    suggestions,
  } = currentPackage;

  const validationSchema = Yup.object({
    name: Yup.string()
      .min(3, "Name must be at least 3 characters")
      .required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    mob_no: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
      .required("Mobile number is required"),
    message: Yup.string().required("Required"),
  });

  if (currentPackage === undefined) {
    return <p>Loading ...</p>;
  } else
    return (
      <div className={`mt-16 ${themeClasses}`}>
        {/* Main Container */}
        <div
          className={` ${themeClasses} shadow-lg rounded-lg overflow-hidden`}
        >
          {/* Header Section with Carousel */}
          <div className="relative">
            <Slider {...carouselSettings}>
              {imageUrl?.map((image, index) => (
                <div key={index}>
                  <img
                    src={image}
                    alt={`Slide ${index + 1}`}
                    className="w-full md:h-[550px] h-96 object-cover"
                  />
                </div>
              ))}
            </Slider>
            <div
              id="id"
              className="absolute md:bottom-2 bottom-2 md:left-0 left-0 bg-[#5b53fb] bg-opacity-80 text-white md:p-6 p-2 rounded-lg shadow-md"
            >
              <h1 className="md:text-4xl text-2xl font-extrabold">{title}</h1>
              <p className="text-lg font-medium mt-2">{duration}</p>
            </div>
          </div>
          {/* Body Section */}
          <div className="p-8 space-y-10">
            {/* Pricing */}
            <div className="flex justify-between items-center">
              <div></div>
              <div className="text-right">
                <p className="text-gray-500 line-through">₹{originalPrice}</p>
                <p className="text-indigo-400 font-bold">
                  Save ₹{originalPrice - pricing}
                </p>
                <p className="text-2xl font-semibold mt-2 text-indigo-500">
                  Price: ₹{pricing}
                </p>
                <button
                  onClick={handleWhatsappClick}
                  className="flex mt-4 animate-vibrate items-center justify-center bg-green-500 hover:bg-green-600 text-white p-3 rounded-full text-base font-semibold transition-transform transform hover:scale-105"
                >
                  <FaWhatsapp className="text-2xl mr-2" />
                  Get Best Deals
                </button>
              </div>
            </div>
            {/* Itinerary Section */}
            <div className="gap-4 flex flex-col justify-start items-start">
              <h2 className={`text-3xl font-bold text-indigo-500`}>
                Day-Wise Itinerary
              </h2>
              <div className="space-y-6">
                {itinerary?.map((item, index) => (
                  <div
                    key={index}
                    className={`${cardClasses} p-4 rounded-lg shadow-lg hover:shadow-xl transition`}
                  >
                    <button
                      onClick={() => toggleAccordion(index)}
                      className="w-full flex justify-between items-center py-2 text-left"
                    >
                      <h3 className="text-lg font-semibold">{item.day}</h3>
                      <span
                        className={`text-teal-400 transform transition-transform duration-300 ${
                          openIndices.includes(index) ? "rotate-180" : ""
                        }`}
                      >
                        {openIndices.includes(index) ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                            className="w-5 h-5"
                          >
                            <path d="M3.75 7.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                            className="w-5 h-5"
                          >
                            <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
                          </svg>
                        )}
                      </span>
                    </button>
                    <div
                      className={`overflow-hidden transition-all duration-500 ease-in-out ${
                        openIndices.includes(index)
                          ? "max-h-[500px]"
                          : "max-h-0"
                      }`}
                    >
                      <p className="mt-2">{item.detail}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Inclusions & Exclusions */}
            <div className="flex flex-wrap justify-between gap-8">
              <div>
                <h2 className="text-2xl pb-2 font-bold text-indigo-400">
                  Inclusions
                </h2>
                <ul className="list-disc ml-6 space-y-2">
                  {inclusions?.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <div>
                <h2 className="text-2xl pb-2 font-bold text-indigo-400">
                  Exclusions
                </h2>
                <ul className="list-disc ml-6 space-y-2">
                  {exclusions?.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            {/* Payment Policy */}
            <h2 className="text-3xl font-bold text-indigo-400">
              Payment Policy
            </h2>
            <p>
              <strong>From 29 Jan 2024 to 31 Mar 2025:</strong> 15 or more days
              before departure: 100%
            </p>
            {/* Cancellation Policy */}
            <h2 className="text-3xl font-bold text-indigo-400">
              Cancellation Policy
            </h2>
            <p>
              <strong>From 29 Jan 2024 to 31 Mar 2025:</strong> 15 or more days
              before departure: 100%
            </p>
            {/* Terms & Conditions */}
            <h2 className="text-3xl font-bold text-indigo-400">
              Terms & Conditions
            </h2>
            <ul className="list-disc ml-6 space-y-2">
              <li>
                This package is valid for a minimum of 2 Pax traveling together.
              </li>
              <li>We don't hold any hotel rooms at this time.</li>
              <li>The price is not applicable during the peak season.</li>
              <li>We offer similar-class hotels upon availability.</li>
            </ul>
            {/* Booking Form */}
            <SuggestionComponent suggestions={suggestions} />;
            <h2 className="text-3xl font-bold text-indigo-400">
              Book Your Package
            </h2>
            <Formik
              initialValues={{
                name: "",
                email: "",
                mob_no: "",
                message: "",
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, isValid, dirty }) => (
                <Form
                  className={`bg-gray-500 text-black p-6 rounded-lg shadow-md space-y-6`}
                >
                  <div>
                    <label
                      htmlFor="name"
                      className="block font-medium text-gray-300"
                    >
                      Name
                    </label>
                    <Field
                      type="text"
                      id="name"
                      name="name"
                      className="w-full p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-400"
                      placeholder="Enter your name"
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="email"
                      className="block font-medium text-gray-300"
                    >
                      Email
                    </label>
                    <Field
                      type="email"
                      id="email"
                      name="email"
                      className="w-full p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-400"
                      placeholder="Enter your email"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="mob_no"
                      className="block font-medium text-gray-300"
                    >
                      Phone
                    </label>
                    <Field
                      type="tel"
                      id="phone"
                      name="mob_no"
                      className="w-full p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-400"
                      placeholder="Enter your phone number"
                    />
                    <ErrorMessage
                      name="mob_no"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="message"
                      className="block font-medium text-gray-300"
                    >
                      Message
                    </label>
                    <Field
                      as="textarea"
                      id="message"
                      name="message"
                      className="w-full p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                      placeholder="Enter your message or inquiries"
                    />
                    <ErrorMessage
                      name="message"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                  <button
                    type="submit"
                    className={`w-full bg-[#5b53fb] text-white p-3 rounded-lg font-bold hover:bg-indigo-400 transition ${
                      !(isValid && dirty)
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:scale-105"
                    }`}
                    disabled={!(isValid && dirty)}
                  >
                    Submit Inquiry
                  </button>
                </Form>
              )}
            </Formik>
            <ToastContainer />
          </div>
        </div>
      </div>
    );
};

export default TourPackageDetail;
